import moment from 'moment-timezone';
import momentTime from 'moment-timezone';

export class TimeZoneHelper {
  static getList() {
    const result = moment.tz.names().map((name) => ({
      name,
      offset: moment.tz(name).utcOffset(),
      description: `UTC ${moment.tz(name).format('Z')} ${name}`
    }));

    // const test = result.map(timezoneCountry => {
    //   const now = new Date()
    //   const date = momentTime.tz(now.toISOString(), timezoneCountry.name).format('DD.MM.YYYY HH:mm:ss');
    //   const timezoneOffset = momentTime.tz(timezoneCountry.name).format('Z');
    //   console.log(date + ' UTC ' + timezoneOffset + ' | ' + timezoneCountry.name)
    //   return timezoneCountry
    // });
    return result;
  }
}